import type { SessionService } from '@efdigital/ll-addon-auth';
import { getOwner } from '@ember/owner';
import Route from '@ember/routing/route';
import type Transition from '@ember/routing/transition';
import { service } from '@ember/service';

import { initializeAuthHandler } from '../data/handlers/auth-handler.ts';

export default class ApplicationRoute extends Route {
  @service declare session: SessionService;

  async beforeModel(transition: Transition) {
    super.beforeModel(transition);

    initializeAuthHandler(getOwner(this)!);
    await this.session.getCurrent();
  }
}
